import MoaPanel from "./moa_panel";
import { MoaFormAnatomy, MOA_FORM_BASE_HTML_CLASS, renderStatusHint } from "../helpers/moa_panel_hints";

// VerifyForm — emailed-code entry. Submit → host.submitCode; Resend → host.resendCode;
// Back → host.changeEmail. The resend countdown is painted here from the AuthClient's
// cooldown truth; the interval is cleared at zero and whenever this panel goes
// inactive.
export const VerifyFormConfig = {
  componentTypeKey: "MoaVerifyForm",
  baseHtmlClass: MOA_FORM_BASE_HTML_CLASS,
  selector: ".member_offer_acceptor__form--verify",
  phase: "verify",

  codeInputSelector: ".member_offer_acceptor__form__field--verify input",
  hintSelector: MoaFormAnatomy.hintSelector,
  backButtonSelector: MoaFormAnatomy.backButtonSelector,
  resendButtonSelector: ".member_offer_acceptor__foot__item--resend button",
  resendCountdownSelector: ".member_offer_acceptor__foot__countdown",

  resendTickMs: 1000,
};

export class VerifyForm extends MoaPanel {
  static get config() { return VerifyFormConfig; }

  constructor(id_or_element, host) {
    super(id_or_element, host, VerifyFormConfig);

    this.codeInput = this.element.querySelector(VerifyFormConfig.codeInputSelector);
    this.hintEl = this.element.querySelector(VerifyFormConfig.hintSelector);
    this.backButton = this.element.querySelector(VerifyFormConfig.backButtonSelector);
    this.resendButton = this.element.querySelector(VerifyFormConfig.resendButtonSelector);
    this.resendCountdownEl = this.resendButton.querySelector(VerifyFormConfig.resendCountdownSelector);
    this.defaultHint = this.hintEl.textContent;
    this.resendTimer = null;

    // Own-element listeners go with the element; the interval does not — it would go on
    // ticking against a detached panel if the pane closed mid-countdown.
    this.element.addEventListener("submit", this.handleSubmit.bind(this));
    this.backButton.addEventListener("click", this.handleBack.bind(this));
    this.resendButton.addEventListener("click", this.handleResend.bind(this));

    this.onDestroy(() => this.stopResendTimer());
  }

  handleSubmit(event) {
    event.preventDefault();
    this.host.submitCode(this.codeInput.value);
  }

  handleBack(event) {
    event.preventDefault();
    this.host.changeEmail();
  }

  handleResend(event) {
    event.preventDefault();
    this.host.resendCode();
  }

  render() {
    const isActive = this.renderPanelVisibility();

    this.codeInput.disabled = !!this.readStateMachineValue("authBusy");

    renderStatusHint(this.hintEl, this.readStateMachineValue("authStatus"), this.defaultHint);

    this.renderResend(isActive);
  }

  // The countdown only runs while this panel is the active one.
  renderResend(isActive) {
    if (!isActive) return this.stopResendTimer();

    this.paintResend();

    if (!this.host.canResend() && !this.resendTimer) {
      this.resendTimer = setInterval(() => {
        this.paintResend();
        if (this.host.canResend()) this.stopResendTimer();
      }, VerifyFormConfig.resendTickMs);
    }
  }

  // The label is static server-rendered text; only the countdown span is painted, so
  // no button-wide textContent write can wipe the span. An empty span collapses via
  // CSS :empty (_foot.scss).
  paintResend() {
    const canResend = this.host.canResend();
    this.resendButton.disabled = !canResend;
    this.resendCountdownEl.textContent = canResend ? "" : `${this.host.resendSecondsRemaining()}s`;
  }

  stopResendTimer() {
    if (this.resendTimer) {
      clearInterval(this.resendTimer);
      this.resendTimer = null;
    }
  }
}
